import React, { useState } from "react";
import axios from "axios";
import ContactImg from "../assets/graphics/contact.svg";

export function ContactForm(props) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [statusMessage, setStatusMessage] = useState("");

  const submitForm = async (e) => {
    e.preventDefault();

    const formData = {
      name,
      email,
      phone,
      message,
    };

    try {
      const response = await axios.post(
        "https://www.alpacasys.com/form/sendAlpacaForm",
        formData
      );
      console.log(formData);
      setStatusMessage("Your message has been sent successfully!");
      setName("");
      setEmail("");
      setPhone("");
      setMessage("");
    } catch (error) {
      console.error(error);
      setStatusMessage("Sorry, something went wrong. Please try again.");
    }
  };

  return (
    <div className="outer">
      <div>
        <form method="POST" id="form" onSubmit={submitForm}>
          <div className="form-container">
            <div className="form-grid">
              <div>
                <h3 className="main-subhead">Connect With An Expert</h3>
                <br />

                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  id="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />

                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />

                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone"
                  id="phone"
                  pattern="[0-9]{10}"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                />
              </div>
              <div className="form-img-container">
                <img src={ContactImg} loading="lazy" alt="Contact" />
              </div>
            </div>
            <div>
              <textarea
                placeholder="Your Message"
                name="message"
                id="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>

              {statusMessage && (
                <span style={{ marginBottom: "10px" }}>{statusMessage}</span>
              )}
            </div>
            <button
              type="submit"
              className="main-btn"
              id="submit"
              name="submit"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
